import { catchType, catcher, createPipeReturn, createPipeThrow, runSyncPipe, } from './syncPipe';
export function syncFlow(...steps) {
    return (initialValue) => {
        return runSyncPipe(initialValue, ...steps);
    };
}
syncFlow.catch = catcher;
syncFlow.catchType = catchType;
syncFlow.return = createPipeReturn;
syncFlow.throw = createPipeThrow;
syncFlow.inputType =
    () => (value) => value;
syncFlow.inputExtends = () => {
    const step = (value) => value;
    return Object.assign(step, { _inputExtends: undefined });
};
export const flow = syncFlow;
//# sourceMappingURL=syncFlow.js.map